import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  securityRecoveryOptionsForRow,
  SECURITY_RECOVERY_QUESTION_PRESETS,
} from "@/lib/commercialLicenseRequests";

/**
 * Tres preguntas de recuperación con catálogo predefinido + respuestas libres.
 */
export default function SecurityRecoveryQuestionFields({
  rows = [],
  onChange,
  disabled = false,
  testIdPrefix = "security-recovery",
}) {
  const setRow = (index, patch) => {
    const next = rows.map((row, i) => (i === index ? { ...row, ...patch } : row));
    onChange?.(next);
  };

  return (
    <div className="space-y-3" data-testid={`${testIdPrefix}-fields`}>
      {rows.map((row, idx) => {
        const options = securityRecoveryOptionsForRow(rows, idx);
        return (
          <div
            key={idx}
            className="rounded-sm border border-slate-100 bg-slate-50/60 p-3 space-y-2"
            data-testid={`${testIdPrefix}-row-${idx + 1}`}
          >
            <Label className="text-[10px] font-semibold text-slate-600">Pregunta {idx + 1}</Label>
            <Select
              value={row.q || ""}
              onValueChange={(v) => setRow(idx, { q: v })}
              disabled={disabled}
            >
              <SelectTrigger
                className="h-9 text-xs"
                data-testid={`${testIdPrefix}-question-${idx + 1}`}
              >
                <SelectValue placeholder="Seleccione una pregunta" />
              </SelectTrigger>
              <SelectContent>
                {options.map((q) => (
                  <SelectItem key={q} value={q}>
                    {q}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <div>
              <Label className="text-[9px] text-slate-500">Respuesta {idx + 1}</Label>
              <Input
                value={row.answer}
                onChange={(e) => setRow(idx, { answer: e.target.value })}
                placeholder="La respuesta que deberá recordar"
                className="h-9 text-xs mt-0.5"
                autoComplete="off"
                disabled={disabled}
                data-testid={`${testIdPrefix}-answer-${idx + 1}`}
              />
            </div>
          </div>
        );
      })}
      <p className="text-[10px] text-slate-500 m-0">
        Catálogo de {SECURITY_RECOVERY_QUESTION_PRESETS.length} preguntas — elija 3 distintas.
      </p>
    </div>
  );
}
